import axios from 'axios'
import store from '..'
import API from '@/common/api'
import UNIQUE from '@/common/unique'

export default {
  namespaced: true,
  state: {
    submitData: [],
    validate: '',
    submitCode: [],
    paymentInfo: {},
    submitSystemInfo: {}
  },
  mutations: {
    submitData (state, data) {
      state.submitData = state.submitData.find(x => x.id === data.id)
        ? state.submitData.map(x => x.id === data.id ? data : x)
        : state.submitData.concat(data)
    },
    setSubmitSystemInfo (state, data) {
      state.submitSystemInfo = data
    },
    initSubmitData (state) {
      state.submitData = []
      state.validate = ''
      state.submitCode = []
      // state.submitSystemInfo = {}
    },
    setValue (state, data) {
      function getIndex (string) {
        const index = string.substring(0, string.indexOf('_'))
        return Number(index)
      }
      const submitModule = state.submitData.find(x => x.id === data.id)
      submitModule.value = data.value
      if (Array.isArray(data.value) && data.type !== 'upload') {
        const valueIndex = data.value.map(x => getIndex(x))
        submitModule.valueIndex = valueIndex
        submitModule.valueOption = []
        valueIndex.forEach(function (x) {
          submitModule.valueOption.push(data.valueOption[x])
        })
        submitModule.condition = data.condition
      } else {
        if (data.valueOption) {
          submitModule.valueOption = data.valueOption.find((x, index) => index === getIndex(data.value))
        }
      }
      if (data.isInput) {
        submitModule.isInput = data.isInput
      } else {
        delete submitModule.isInput
      }
      submitModule.passed = data.passed
    },
    setValidate (state, type) {
      state.validate = type
    },
    setSubmitCode (state, data) {
      state.submitCode = data
    }
  },
  actions: {
    async getSystemCode ({ state }) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-system-code&siteid=${API.SITE_INFO.site}`)
        // db에 추가하면 백엔드 오류나서 roomservice, amenity, taxi 외에는 프론트에서 추가함(백엔드에서 수정안해줌)
        // 여기서 추가한 시스템코드는 에디터 store/admin.js에도 똑같이 추가해줘야함
        const expressCheckin = {
          id: 'system_express_checkin',
          label: 'Express Checkin',
          type: 'system'
        }
        const checkout = {
          id: 'system_checkout',
          label: 'Checkout',
          type: 'system'
        }
        const survey = {
          id: 'system_survey',
          label: 'Survey',
          type: 'system'
        }
        const mobility = {
          id: 'system_mobility',
          label: 'Mobility',
          type: 'system'
        }
        const others = [
          expressCheckin,
          checkout,
          survey,
          mobility
        ]
        const codeData = res.data.message.map(x => {
          return {
            id: x.name,
            label: x.desc,
            type: 'system'
          }
        })
        const array = res.data && res.data.message ? codeData : []
        return array.concat(others)
      } catch (ex) {
        return false
      }
    },
    async getUserCode ({ state }) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-cat-code&siteid=${API.SITE_INFO.site}`)
        const codeData = res.data.message.map(x => {
          return {
            id: x.id,
            label: x.label,
            type: 'user'
          }
        })
        return res.data.message ? codeData : []
      } catch (ex) {
        return false
      }
    },
    async getSubmitCode ({ state, dispatch }) {
      const res = await Promise.all([
        dispatch('getSystemCode'),
        dispatch('getUserCode')
      ])
      if (res && res.length) {
        const systemCode = res[0] ? res[0] : []
        const userCode = res[1] ? res[1] : []
        state.submitCode = systemCode.concat(userCode)
      }
      return res
    },
    async setSubmit ({ state, dispatch }, data) {
      const isPayment = store.state.siteInfo.commerce
      const isRoomCharge = store.state.siteInfo.roomCharge
      const validAmount = data ? data.price && (data.price.info && data.price.info.total && data.price.info.total > 0) : null
      const paymentId = UNIQUE.fileid()
      const isExpressCheckin = data && data.payload && data.payload.length === 1 && data.payload[0].submitId.includes('express_checkin')
      if (data) {
        if (isPayment && validAmount) {
          store.commit('payment/setOrder', { id: paymentId, data: data })
          return {
            status: 200,
            payment: 'nice',
            paymentId: paymentId,
            ...isRoomCharge && {
              roomCharge: true
            }
          }
        } else if (isExpressCheckin) {
          return dispatch('expressCheckin', data.payload[0])
        } else {
          return dispatch('request', data)
        }
      }
    },
    // 안씀, 한번에 모두 보내면 서버에서 catCode별로 전달하도록 처리
    setRequest ({ state, dispatch }, data) {
      const isArray = data.length
      /**
       * 카트 등에서 여러 건을 동시에 요청할 경우
       * submitId로 재배열 하여
       * promise all
       */
      if (isArray) {
        const submitCodes = [...new Set(data.map(x => x.submitId))]
        const requestData = submitCodes.map(x => {
          return {
            submitId: x,
            isArray: true,
            payload: data.filter(item => item.submitId === x)
          }
        })
        return Promise.all(requestData.map(data => dispatch('request', data))).then((res) => {
          return res
        })
      } else {
        return dispatch('request', data)
      }
    },
    async expressCheckin ({ state }, data) {
      try {
        const site = store.state.authentication.site
        const submitSystemInfo = state.submitSystemInfo
        const userInfo = {
          ...submitSystemInfo && {
            systemInfo: submitSystemInfo
          }
        }
        const payload = {
          ...data,
          userInfo: userInfo
        }
        const res = await axios.post(`${API.BASE_URL}/checkin/submit`, {
          cmd: 'sc-checkin-submit',
          siteid: site,
          data: {
            cmd: 'sc-service',
            func: 'set-submit',
            catCode: 'system_express_checkin',
            userInfo: userInfo,
            payload: payload
          }
        })
        store.commit('payment/setUserInfo', null)
        return res
      } catch (ex) {
        return ex.response.data
      }
    },
    async request ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const guestInfo = store.state.guest.guestInfo
        const staff = siteInfo.staff
        const site = siteInfo.site
        const space = siteInfo.space
        const ota = siteInfo.public ? await store.dispatch('authentication/getOtaKey', true) : siteInfo.k
        const metakey = siteInfo.metakey
        const submitSystemInfo = state.submitSystemInfo
        const userInfo = {
          ...store.state.payment.userInfo,
          ota: ota,
          ...metakey && {
            metakey: metakey
          },
          ...submitSystemInfo && {
            systemInfo: submitSystemInfo
          },
          ...guestInfo && {
            ...guestInfo.stayAfter && {
              stayAfter: guestInfo.stayAfter
            },
            ...guestInfo.stayBefore && {
              stayBefore: guestInfo.stayBefore
            }
          }
        }
        const payload = data.isArray
          ? data.payload.map(x => {
            return {
              ...x,
              userInfo: userInfo,
              ...staff && {
                staff: `${staff}.${site}`
              },
              ...data.paid !== undefined && {
                paid: data.paid
              }
            }
          })
          : Object.assign(data, {
            userInfo: userInfo,
            ...staff && {
              staff: `${staff}.${site}`
            },
            ...data.paid !== undefined && {
              paid: data.paid
            }
          })
        const res = await axios.post(`${API.BASE_URL}/${site}/${space}/service/${ota}`, {
          ...API.SUBMIT_PARAMS,
          catCode: data.submitId || 'system_room_service',
          userInfo: userInfo,
          payload: payload,
          ...data.partnerOrder && {
            partnerOrder: data.partnerOrder
          }
        })
        store.commit('payment/setUserInfo', null)
        return res
      } catch (ex) {
        return ex.response.data
      }
    },
    async getOrderId ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey') : siteInfo.k
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-viewer-order',
          func: 'get-order-id',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ...siteInfo.metakey && {
            metakey: siteInfo.metakey
          },
          ota: ota,
          test: siteInfo.test && siteInfo.test === '1',
          ...data.returnURL && { returnURL: data.returnURL },
          payload: {
            cmd: 'sc-service',
            func: 'set-submit',
            catCode: data.submitId || 'system_room_service',
            payload: data.isArray ? data.payload : data
          }
        })
        state.paymentInfo = res.data.message
        return { ...res.data, payment: 'nice' }
      } catch (ex) {
        return ex.response.data
      }
    },
    async getOrderHistory ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey', true) : siteInfo.k
        const res = await axios.post(`${API.BASE_URL}/service/commerce`, {
          cmd: 'sc-viewer-order-history',
          func: 'get-orders-ota',
          siteid: siteInfo.site,
          ...siteInfo.metakey && {
            metakey: siteInfo.metakey
          },
          ota: ota
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async launchCert ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/service/self-auth`, {
          cmd: 'sc-launch-info',
          siteid: siteInfo.site,
          returnUrl: data.returnUrl
        })
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    async getCertInfo ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/self-auth`, {
          cmd: 'sc-result',
          rId: data.authId
        })
        return res.data.message
      } catch (ex) {
        return false
      }
    }
  },
  getters: {
    getSubmitData: function (state) {
      const page = store.getters['page/getPage']
      const pageModule = page && page.module
      const moduleIds = pageModule && pageModule.map(x => x.id)
      const submitData = state.submitData
      return submitData.filter(x => moduleIds && moduleIds.includes(x.id))
    },
    getSubmitCode: state => state.submitCode,
    getSubmitValues: function (state) {
      const valueData = state.submitData.filter(x => x.value && x.value.length)
      const result = valueData.map((x, index) => {
        return {
          id: `${index}_${x.id}`,
          name: x.name,
          displayLabel: x.displayLabel,
          value: x.value,
          ...x.valueOption && {
            valueOption: x.valueOption
          }
        }
      })
      return result
    }
  }
}
